import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";

/**
 * BlueRingPreset — extends PrimeNG's built-in Lara theme.
 *
 * Overrides:
 *  - Primary palette: emerald (Lara default) → blue (#007ad9)
 *    Affects datepicker selected dates, checkboxes, and all primary-accented components.
 *  - Focus ring: replaced token-based outline with a CSS box-shadow glow
 *    (0 0 0 0.2em #8dcdff) shown strictly on :focus — never at rest.
 *  - Hover/focus border: #007ad9 across all form fields.
 */
export const BlueRingPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: "{blue.50}",
      100: "{blue.100}",
      200: "{blue.200}",
      300: "{blue.300}",
      400: "{blue.400}",
      500: "{blue.500}",
      600: "{blue.600}",
      700: "{blue.700}",
      800: "{blue.800}",
      900: "{blue.900}",
      950: "{blue.950}",
    },
    focusRing: { width: "0", style: "none", color: "transparent", offset: "0" },
    colorScheme: {
      light: {
        primary: { color: "#007ad9", inverseColor: "#ffffff", hoverColor: "#005fa3", activeColor: "#004d87" },
        formField: { hoverBorderColor: "#007ad9", focusBorderColor: "#007ad9", shadow: "none" },
      },
      dark: {
        primary: { color: "#007ad9", inverseColor: "#ffffff", hoverColor: "#005fa3", activeColor: "#004d87" },
        formField: { hoverBorderColor: "#007ad9", focusBorderColor: "#007ad9", shadow: "none" },
      },
    },
  },
  css: () => `
    .p-inputtext:enabled:focus,
    .p-textarea:enabled:focus,
    .p-select:not(.p-disabled).p-focus,
    .p-multiselect:not(.p-disabled).p-focus,
    .p-autocomplete:not(.p-disabled).p-focus,
    .p-treeselect:not(.p-disabled).p-focus,
    .p-cascadeselect:not(.p-disabled).p-focus,
    .p-select-overlay .p-inputtext:focus,
    .p-multiselect-overlay .p-inputtext:focus {
      outline: none !important;
      border-color: #007ad9 !important;
      box-shadow: 0 0 0 0.2em #8dcdff !important;
    }
  `,
});
